<ng-container *ngIf="listings === null" [ngTemplateOutlet]="loadingTemplate"></ng-container>
<ng-container *ngIf="listings !== null">
  <ng-container *ngIf="listings.length > 0; else noListingsTemplate">
    <div class="listings flex-wrap">
      <ng-container *ngFor="let listing of listings">
        <a [routerLink]="['/equipment/marketplace/listing', listing.hash, listing.slug]" class="line-item">
          <astrobin-marketplace-listing-card [listing]="listing"></astrobin-marketplace-listing-card>
        </a>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #noListingsTemplate>
  <astrobin-nothing-here [withAlert]="false" [withInfoSign]="false" class="d-inline-block"></astrobin-nothing-here>
  {{ "Do you want to sell something?" | translate }}
  <a (click)="equipmentMarketplaceService.onCreateListingClicked($event)" href="#">
    {{ "Create a listing" | translate }}.
  </a>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
